<template>
<!--    <div-->
<!--      @dragover.prevent="dragOver"-->
<!--      @dragleave.prevent="dragLeave"-->
<!--      @drop.prevent="drop"-->
<!--    >-->
    <div
      @dragover.prevent="dragOver"
      @dragleave.prevent="dragLeave"
      @drop.prevent="drop"
    >
      <validation-provider v-slot="{ errors }" ref="provider" name="Image" :vid="'validate-'+uniqueId">
        <div v-show="imagePreviews.length === 0" class="imageUploader" @click="chooseImage()">
<!--          <input-->
<!--            v-bind="$attrs"-->
<!--            ref="fileInput"-->
<!--            :multiple="multiple"-->
<!--            type="file"-->
<!--            class="imageUploader__input"-->
<!--            accept="image/*"-->
<!--            @change="fileChanged"-->
<!--          />-->
          <v-icon v-show="dragging" size="120" color="grey darken-4"
            >mdi-image-size-select-large</v-icon
          >

          <v-icon v-show="!dragging" size="100" color="grey darken-4"
            >mdi-image-filter-hdr</v-icon
          >
          <p v-show="!dragging" class="mb-0 bw-secondary--text">
            Browse Images
          </p>
        </div>
        <p
          v-for="(error, idx) in errors"
          :key="`error-${idx}`"
          class="error--text"
        >
          {{ error }}
        </p>
      </validation-provider>
      <div v-show="imagePreviews.length > 0" class="imageUploader" id="imageUploader">
        <v-row>
          <v-col v-if="!multiple">
            <h3 class="text-left">Uploaded Image:</h3>
            <div class="cropper-container">
              <img
                ref="displayImg"
                :src="cropperPreview"
                class="imageUploader__image"
              />
            </div>
            <h3 class="mt-2 text-left">Image Preview:</h3>
            <div :style="$vuetify.breakpoint.mdAndDown ? 'max-width : 80vw;' : ''">
                <v-img 
                    contain
                    :max-width="$vuetify.breakpoint.mdAndDown ? 650 : ''" 
                    :src="cropperDestination"
                  ><v-btn
                    class="imageUploader__delete"
                    x-small
                    color="red"
                    dark
                    fab
                    aria-label="Remove Image"
                    @click="removeImage(0)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn></v-img
                >
            </div>
            <v-row>
              <v-col>
                <v-btn
                        class="mt-3 mb-14"
                        rounded
                        dark
                        elevation="0"
                        color="bw-secondary"
                        @click="apply()"
                >Apply</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-for="(image, index) in imagePreviews"
            v-else
            :key="`image-${index}`"
            v-bind="previewImageCols"
          >
            <v-img
              :aspect-ratio="computedAR"
              :alt="image.name"
              :src="image.src"
              class="imageUploader__image"
            >
              <v-btn
                class="imageUploader__delete"
                x-small
                color="red"
                dark
                fab
                aria-label="Remove Image"
                @click="removeImage(index)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn></v-img
            >
          </v-col>
          <v-col v-if="dragging" v-bind="previewImageCols">
            <v-icon v-show="dragging" x-large color="bw-secondary"
              >mdi-image-size-select-large</v-icon
            >
          </v-col>
          <v-col v-if="multiple" v-bind="previewImageCols">
            <v-container fill-height class="justify-center">
              <v-btn
                  aria-label="Add image"
                  color="bw-secondary"
                  fab
                  outlined
                  x-large
                  @click="append"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-container>
          </v-col>
        </v-row>
      </div>
      <media-manager
          v-if="!loading"
          :entity="uploadAssignment"
          :entity-id="this.uploadAssignmentId||0" :is-admin="this.isAdmin"
          :nav-search="{entity: uploadAssignment, itemId:this.uploadAssignmentId||0}"
          :super-admin="this.isSuperAdmin"
          enable-tabs="image"
          show-tab="image"
          @file-chosen="fileChanged({ target: { files: [$event] } })"
      >
      </media-manager>
    </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import Cropper from 'cropperjs'
import $api from '@api/api';
import MediaManager from '@components/MediaComponents/mediaManager'

export default {
  name: 'TypeImageUpload',
  components: {
    ValidationProvider,
    MediaManager,
  },
  inheritAttrs: false,
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: undefined,
      required: true,
    },
    maxFiles: {
      type: Number,
      default: 1,
    },
    // NumberxNumber
    // i.e. 200x300
    dimensions: {
      type: [String, Boolean],
      default: false,
    },
    minDimensions: {
      type: [String, Boolean],
      default: false,
    },
    maxDimensions: {
      type: [String, Boolean],
      default: false,
    },
    // square, landscape, or portrait
    orientation: {
      type: String,
      default: 'any',
    },
    // kb, mb, or gb (enforced as kib, mib, gib)
    maxFileSize: {
      type: [String, Boolean],
      default: false,
    },
    minFileSize: {
      type: [String, Boolean],
      default: false,
    },
    uniqueId: {
      type:[Number, String],
      default:1
    },
    uploadAssignmentId: {
      type:[Number, String],
    },
    uploadAssignment: {
      type:String,
    },
      isAdmin: {
          type: Boolean,
          default: false
      },
      isSuperAdmin: {
          type: Boolean,
          default: false
      }
  },
  data() {
    return {
      loading: true,
      imagePreviews: [],
      dragging: false,
      errorMessages: [],
      cropper: {},
      cropperPreview: null,
      cropperDestination: {},
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value || []
      },
      set(v) {
        this.makeImagePreviews(v)

        this.$emit('input', v)
      },
    },
    computedAR() {
      if (this.multiple) return 1

      return undefined
    },
    previewImageCols() {
      if (this.multiple)
        return {
          cols: 6,
          md: 4,
        }

      return {
        cols: 12,
      }
    }
  },
  mounted() {
    this.makeImagePreviews(this.localValue);
    this.loading = false;
  },
  methods: {
    chooseImage() {
      $('#media-manager').modal('show');
    },
    loadCropper(file) {
      const mimeType = file.type;
      const fileType = (file.original_file_name||file.name||'').split('.').pop()
      this.$nextTick(() => {
        this.cropper = new Cropper(this.$refs.displayImg, {
          aspectRatio: 16 / 9,
          autoCropArea: 1,
          viewMode: 1,
          dragMode: 'move',
          background: false,
          cropBoxMovable: true,
          cropBoxResizable: true,
          setCropBoxData: { width: '800' },
          crop: (e) => {
            const cropperCanvas = this.cropper.getCroppedCanvas({maxWidth: 800});
            this.cropperDestination = cropperCanvas.toDataURL(mimeType)

            if( !this.localValue[0].cropperSettings ) this.localValue[0].cropperSettings = {};
            this.localValue[0].cropperSettings = {
              ...this.localValue[0].cropperSettings,
              ...e.detail,
            };


            // cropperCanvas.toBlob((blob) => {
            //   this.$emit('input', [
            //     new File([blob], `${new Date()}.${fileType}`, {
            //       type: mimeType,
            //       lastModified: new Date(),
            //     }),
            //   ])
            // }, mimeType)
          },
          ready: this.crop,
        })
      })
    },
    dragOver() {
      this.dragging = true
    },
    dragLeave() {},
    drop(e) {
      let onlyImages = true
      e.dataTransfer.files.forEach((file) => {
        if (file.type.startsWith('image') === false) onlyImages = false
      })
      if (onlyImages) {
        this.fileChanged({ target: { files: e.dataTransfer.files } })
      } else {
        this.$refs.provider.applyResult({
          errors: [`Unsupported file type. Only image files are allowed`], // array of string errors
          valid: false, // boolean state
          failedRules: {}, // should be empty since this is a manual error.
        })
      }
      this.dragging = false
    },
    async fileChanged(e) {
      if (e.target.files.length === 0) return
      this.errorMessages = []
      let files
      if (this.multiple) {
        if (this.localValue.length + e.target.files.length > this.maxFiles) {
          this.$refs.provider.applyResult({
            errors: [`Maximum number of files allowed is ${this.maxFiles}`], // array of string errors
            valid: false, // boolean state
            failedRules: {}, // should be empty since this is a manual error.
          })
        } else {
          files = [...this.localValue, ...e.target.files]
        }
      } else {
        files = [e.target.files[0]]
      }

      if (await this.validate(files)) {
        this.localValue = files;
        // save the file references to the server
          const saveFiles = files.filter(x => !x.id);
          if( saveFiles.length ) {
              const medias = (await $api.medias.addMedia(saveFiles, {upload_assignment_id: this.uploadAssignmentId, upload_assignment: this.uploadAssignment})).data;
              for (let media of medias) {
                  const i = this.localValue.findIndex(x => x.name === media.original_file_name);
                  if (i > -1) this.localValue[i] = {...this.localValue[i], ...media};
              }
          }
      }

        // scroll to preview
        // element which needs to be scrolled to
        const element = this.$el.querySelector("#imageUploader");
        // scroll to element
        element.scrollIntoView(); //{ behavior: 'smooth'}
    },
    async validate(files) {
      // dimensions and orientation
      const validImageSizes = await this.validateImageSizes(files)
      const validFileSizes = this.validateFileSizes(files)

      const isValid = [validImageSizes, validFileSizes].every((v) => v === true)

      this.$refs.provider.applyResult({
        errors: this.errorMessages, // array of string errors
        valid: isValid, // boolean state
        failedRules: {}, // should be empty since this is a manual error.
      })

      return isValid
    },
    makeImagePreviews(files) {
      const res = Array.from(files).map(async (file) => {
        const imageObj = {
          name: file.name,
          type: file.type,
          src: file.originalURL || file.url || await this.readAsDataURL(file),
        }
        return imageObj
      })

      Promise.all(res).then((r) => {
        this.imagePreviews = r
        if (r.length > 0) {
          // TODO: support for multiple images
          this.cropperPreview = r[0].src
          this.loadCropper(r[0])
        }
      })
    },
    validateFileSizes(files) {
      if (!this.maxFileSize && !this.minFileSize) return true

      const validArr = []
      const powers = {
        kb: 1,
        mb: 2,
        gb: 3,
      }

      const convertBytes = (file, power) => {
        return file / Math.pow(1024, power)
      }

      files.forEach((file) => {
        if (this.minFileSize) {
          const size = this.minFileSize.slice(0, -2)
          const suffix = this.minFileSize.slice(-2)
          if (
            convertBytes(file.size, powers[suffix.toLowerCase()]) <
            Number(size.trim())
          ) {
            validArr.push(false)
            this.errorMessages.push(`File is too small`)
          } else {
            validArr.push(true)
          }
        }
        if (this.maxFileSize) {
          const size = this.maxFileSize.slice(0, -2)
          const suffix = this.maxFileSize.slice(-2)
          if (
            convertBytes(file.size, powers[suffix.toLowerCase()]) >
            Number(size.trim())
          ) {
            validArr.push(false)
            this.errorMessages.push(`File is too large`)
          } else {
            validArr.push(true)
          }
        }
      })

      return validArr.every((v) => v === true)
    },
    validateImageSizes(files) {
      const checkDimensions = this.getValidationDimentions()
      const checkOrientation = this.orientation !== 'any'

      const promises = Array.from(files).map(async (file) => {
        const imageObj = {
          name: file.name,
          src: file.originalURL || file.url || await this.readAsDataURL(file),
        }
        return imageObj
      })

      return Promise.all(promises).then(async (files) => {
        const validArr = []
        for (const file of files) {
          const [imgWidth, imgHeight] = await this.getImageDimensions(file)
          // validate dimensions
          if (checkDimensions) {
            const { operator, requirements } = checkDimensions
            const [width, height] = requirements.split('x')
            if (
              eval(`${width}${operator}${imgWidth}`) && // eslint-disable-line no-eval
              eval(`${height}${operator}${imgHeight}`) // eslint-disable-line no-eval
            ) {
              validArr.push(true)
            } else {
              validArr.push(false)
              this.errorMessages.push(
                `Image dimensions don't meet requirements`
              )
            }
          }
          // validate orientation
          if (checkOrientation) {
            const validOrientations = {
              landscape: ['landscape', 'square'],
              portrait: ['portrait', 'square'],
              square: ['square'],
            }

            let imgOrientation
            if (imgWidth === imgHeight) imgOrientation = 'square'
            else if (imgWidth > imgHeight) imgOrientation = 'landscape'
            else imgOrientation = 'portrait'

            if (validOrientations[this.orientation].includes(imgOrientation)) {
              validArr.push(true)
            } else {
              validArr.push(false)
              this.errorMessages.push(
                `Image orientation must be ${this.orientation}`
              )
            }
          }
        }
        return validArr.every((v) => v === true)
      })
    },
    getValidationDimentions() {
      if (
        [this.dimensions, this.minDimensions, this.maxDimensions].every(
          (v) => v === false
        )
      ) {
        return false
      }

      let dims, operator
      if (this.dimensions) {
        operator = '='
        dims = this.dimensions
      } else if (this.minDimensions) {
        operator = '<'
        dims = this.minDimensions
      } else if (this.maxDimensions) {
        operator = '>'
        dims = this.maxDimensions
      }

      return {
        requirements: dims,
        operator,
      }
    },
    getImageDimensions(file) {
      return new Promise(function (resolve, reject) {
        const img = new Image()
        img.onload = function () {
          resolve([img.width, img.height])
        }
        img.onerror = function () {
          reject(img)
        }
        img.src = file.src
      })
    },
    readAsDataURL(file) {
      return new Promise(function (resolve, reject) {
        const fr = new FileReader()
        fr.onload = function () {
          resolve(fr.result)
        }
        fr.onerror = function () {
          reject(fr)
        }
        fr.readAsDataURL(file)
      })
    },
    append() {
      this.$refs.fileInput.click()
    },
    removeImage(index) {
      this.localValue = this.localValue.filter((v, i) => i !== index) // filter instead of splice so the set is triggered
      this.$refs.fileInput.value = null
      this.cropper.destroy()
    },
    apply() {
      for (let file of this.localValue) {
        if (!file.originalURL) file.originalURL = file.url;

        // if it's a cloudinary image then change the url
        if (file.originalURL.indexOf("cloudinary.com") > -1 && file.cropperSettings) {
          let i = file.originalURL.lastIndexOf("/upload/");

          // let aspectRatio = this.chosenFile.width / this.chosenFile.height;
          let url = file.originalURL.substring(0, i + 8);
          url += "x_" + Math.round(file.cropperSettings.x) + ",";
          url += "y_" + Math.round(file.cropperSettings.y) + ",";
          url += "w_" + Math.round(file.cropperSettings.width) + ",";
          url += "h_" + Math.round(file.cropperSettings.height) + ",";

          if (file.cropperSettings.rotate) url += "a_" + Math.round(file.cropperSettings.rotate) + ",";
          // horizontal flip, cloudinary is opposite cropper js
          if (file.cropperSettings.scaleX < 0) url += "a_hflip,";
          // vertical flip, cloudinary is opposite cropper js
          if (file.cropperSettings.scaleY < 0) url += "a_vflip,";

          url += "c_crop";
          file.url = url + file.originalURL.substring(i + 7);
        }
      }

      this.$emit('applied', this.localValue);
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';
.imageUploader {
  position: relative;
  padding: 20px;
  border: 1px solid map-get($grey, 'base');
  border-radius: $border-radius-root;
  text-align: center;
  cursor: pointer;

  &__input {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    display: block;
    z-index: 1;
  }

  &__image {
    position: relative;
  }

  &__delete {
    position: absolute;
    top: 8px;
    right: 8px;
  }
}

.cropper-container {
  max-height: 600px;
  max-width: 100%;
  overflow: hidden;
}
</style>
